// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__1pKpQ","data":"Header_data__2XGnA","divx":"Header_divx__2n6zn","menu":"Header_menu__3xq9X"};